import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { enum_api_uri } from "../utils/enum";

interface RequestQuery {
    category: string;
}

interface RequestBody {
    name: string;
    subject: string;
    contents: string;
    notice: number;
    b_file: File[];
}

export type PostFaqRequest = RequestQuery & RequestBody;

interface PostFaqResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

const createFormData = (data: RequestBody) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof RequestBody];

        if (key === "b_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("b_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePostConsoleFaq = (): UseMutationResult<PostFaqResponse, Error, PostFaqRequest, unknown> => {
    // const queryClient = useQueryClient();
    const accessToken = useConsoleAuthStore(state => state.accessToken);
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
    };

    return useMutation<PostFaqResponse, Error, PostFaqRequest>({
        mutationFn: async (data: PostFaqRequest) => {
            const url = enum_api_uri.post_console_faq.replace(":category", data.category);
            const formData = createFormData({
                name: data.name,
                subject: data.subject,
                contents: data.contents,
                notice: data.notice,
                b_file: data.b_file,
            });
            const response = await axiosInstance.post(url, formData, { headers });
            return response.data;
        },
        onSuccess: data => {
            return data;
        },
    });
};
